import {takeEvery, put, call, takeLatest} from "redux-saga/effects"

import {
    FIND_PRODUCTS_BY_ID_CATEGORY,
} from "./actionTypes"


import {
    findProductsByCategorySuccess,
    apiFindProductsByCategoryError
} from "./actions"


import {
    findProductsByCategoryID
} from "../../../helpers/catalog_helper"

function* findProductsByCategory({payload: {query}}) {
    try {

        const response = yield call(findProductsByCategoryID, query)
        const {data} = response;
        yield put(findProductsByCategorySuccess(data))

    } catch (error) {
        yield put(apiFindProductsByCategoryError(error))
    }
}


function* CatalogProductsByCategorySaga() {
    yield takeEvery(FIND_PRODUCTS_BY_ID_CATEGORY, findProductsByCategory)
}

export default CatalogProductsByCategorySaga
